var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel',{attrs:{"title":"在租数量"}},[_c('div',{staticClass:"center a font24",staticStyle:{"line-height":"100px"}},[_c('router-link',{attrs:{"to":"/normal/portals/rented-count-detail"}},[_vm._v(" "+_vm._s(_vm.rentedCount)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }